import {DomainObject} from 'shared/store';
import {observable} from 'mobx';

class Draft extends DomainObject {
  @observable draftObject;
  @observable autosavedAt;
}

export default Draft;
